export default class Model {
  constructor(data) {
    Object.entries(data).forEach(([k, v]) => {
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty(k)) {
        this[k] = v;
      }
    });
  }
}